import * as React from "react"
import PropTypes from "prop-types"
//import { Link } from "gatsby"
import Navbar from "../ui/navbar"

import {
  Box,
} from '@chakra-ui/react'

const Header = ({ siteTitle }) => (
  <header>
    <Box maxW="7xl" mx="auto">


      <Navbar />

    </Box>

    {/* <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1>
    </div> */}
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
